module.exports = __webpack_public_path__ + "static/media/4-min.76ba9980.png";